module.exports = __webpack_public_path__ + "img/team-member-01.9f08c14a.jpg";